<cui-background productLogoSrc="assets/cui/logo/cicero-move-white.svg">
  <form *ngIf="agency" (ngSubmit)="submit()" novalidate #loginForm="ngForm">
    <h1>{{agency.name}}</h1>

    <div class="input-row">
      <mat-icon svgIcon="login-22x"></mat-icon>
      <mat-form-field>
        <input matInput
               type="text"
               name="username"
               required
               placeholder="Brugernavn"
               [(ngModel)]="username">
      </mat-form-field>
    </div>

    <div class="input-row">
      <mat-icon svgIcon="password"></mat-icon>
      <mat-form-field cui>
        <input matInput
               type="password"
               name="password"
               required
               placeholder="Kodeord"
               [(ngModel)]="password">
      </mat-form-field>
    </div>

    <div class="button-container">
      <button mat-raised-button cui type="submit" color="default" [disabled]="loginForm.form.invalid">Log på</button>
    </div>
  </form>

  <div *ngIf="!agency && !loading" class="no-access">
    <p>Dette bibliotek har ikke adgang til Cicero Move. Kontakt Systematic for at købe adgang.</p>
    <a href="https://da.systematic.com/contact/sales/library-learning/">https://da.systematic.com/contact/sales/library-learning/</a>
  </div>
</cui-background>



// WEBPACK FOOTER //
// ./src/app/authentication/login/login.component.html